import { getLang } from 'i18n/l10n';
import { Licenses } from 'types/common';

const defaultRootUrl = process.env.NODE_ENV === 'production'
  ? 'https://www.winamax.fr'
  : 'https://www.prelive.winamax.fr';

const config = window.config || {};

export const RootUrl = config.ROOT_URL || defaultRootUrl;

export const BasePath = config.BASE_PATH || process.env.BASE_PATH || '';

export const RedirectServices = Object.freeze({
  PLAY_BETTING: 'playbetting',
  PLAY_POKER: 'playpoker',
  PRONOS_JOIN: 'pronos-join',
  ACCOUNT: 'account',
  DEPOSIT: 'deposit',
  RESPONSIBLE_GAMING: 'responsible_gaming',
  LOGIN: 'login',
});

const redirectUrlTo = category =>
  `${RootUrl}/signup/redirect.php?category=${category}&lang=${getLang()}`;
const bettingRedirectUrlTo = service =>
  `${RootUrl}/betting/redirect.php?service=${service}&lang=${getLang()}`;
const redirectTo = service =>
  `${RootUrl}/redirect/index.php?service=${service}&lang=${getLang()}`;

// variable isIOS of lib/useragent is not initialized here
const isIOS = window.navigator.userAgent.indexOf('iPhone') !== -1;
const isPokerEmbedded = config.IS_POKER_EMBEDDED || false;
const isBettingEmbedded = config.IS_BETTING_EMBEDDED || false;
export const isEmbedded = isPokerEmbedded || isBettingEmbedded || false;
const isPronos = window.location.pathname === `${BasePath}/pronos`;

export const getRedirectUrl = (service) => {
  switch (service) {
    case RedirectServices.PLAY_BETTING:
      return (
        (isEmbedded && isIOS && 'wam://close')
        || (isPokerEmbedded && !isBettingEmbedded && !isIOS && 'wam://signin')
        || redirectUrlTo('playbetting')
      );
    case RedirectServices.PLAY_POKER:
      return (
        (isPokerEmbedded && isIOS && 'wam://close')
        || (isBettingEmbedded && isIOS && 'wam://signin')
        || (isEmbedded && !isIOS && 'wam://signin')
        || redirectUrlTo('playpoker')
      );
    case RedirectServices.PRONOS_JOIN:
      return (isEmbedded && isIOS && 'wam://close') || bettingRedirectUrlTo('pronos-join');
    case RedirectServices.ACCOUNT:
      return config.ACCOUNT_URL || redirectUrlTo('account');
    case RedirectServices.DEPOSIT:
      return redirectUrlTo('deposit');
    case RedirectServices.RESPONSIBLE_GAMING:
      return redirectTo('responsible_gaming');
    default:
      return redirectTo(service);
  }
};

export const getHomeUrl = () =>
  (isPokerEmbedded && !isBettingEmbedded && getRedirectUrl(RedirectServices.PLAY_POKER))
  || (isBettingEmbedded && getRedirectUrl(RedirectServices.PLAY_BETTING))
  || RootUrl;

export const getLoginUrl = () =>
  (isPronos && getRedirectUrl(RedirectServices.PronosUrl)) || getHomeUrl();

export const getAppleStorePath = (license) => {
  switch (license) {
    case Licenses.FR:
      return 'https://apps.apple.com/fr/app/winamax-paris-sportifs-poker/id385720307';
    case Licenses.ES:
      return 'https://apps.apple.com/es/app/winamax-apuestas-y-p%C3%B3ker/id385720307';
    case Licenses.DE:
      return 'https://apps.apple.com/de/app/winamax-sportwetten/id1575718517';
    default:
      return 'https://apps.apple.com/fr/app/winamax-paris-sportifs-poker/id385720307';
  }
};

export const getGooglePlayPath = () => {
  return 'http://play.google.com/store/apps/details?id=com.winamax.winajs';
};
